import { EBroadcastTypes } from '@/types/session.types';
import { TBroadcastTypePickerOptions } from './broadcast-type-picker.types';

const getBroadcastTypeLabel = (broadcastType: TBroadcastTypePickerOptions): string => {
  switch (broadcastType) {
    case EBroadcastTypes.greenroom:
      return 'Greenroom';
    case EBroadcastTypes.rtmps:
      return 'Encoder';
    case 'teams':
      return 'Microsoft Teams';
    case 'zoom':
      return 'Zoom';
    default:
      return broadcastType;
  }
};

export default getBroadcastTypeLabel;
